<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import polyBuilder from './functions/polyBuilder';
	import Fraction from './functions/fractionClass';

	export let uqn: number;

	let de: string;
	let initialM: string;
	$: [de, initialM] = uqnToQn(uqn);

	function uqnToQn(u:number):string[]{
		let [t,a,b,c] = uqnSplit(u);
		let bQn = (t<3 || t==4) ? new Fraction(b,1) : new Fraction(b, 10).simplify();
		let poly = t<3 ? polyBuilder([a,bQn.multiply(-1)],"m") : polyBuilder([bQn,-a],"m",1,false); 
		poly = "\\displaystyle \\frac{\\mathrm{d}m}{\\mathrm{d}t}=" + poly;
		let iM = t%2==1? new Fraction(c,10).multiply(a).divide(bQn) : new Fraction(c+10,10).multiply(a).divide(bQn);
		return [poly, iM.toString()];
	}
</script>

<div class="qnpart">
	<span style="margin-right:1em"><Katex math={de}/>.</span> <Katex math={"m="+initialM}/> when <Katex math={"t=0"}/>
</div>

<style>
	.qnpart{
		margin-left: 0.5em;
	}
</style>